// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"321ece0d","239":"0daa6356","667":"ed657ebf"}[chunkId] + ".chunk.js";
};